export default [
    {
        path: '/projects',
        name: 'Projects_List',
        component: () => import('@/views/todo/project/projects.vue'),
        meta: {
            authRequired: true,
            permission: 'projects.index'
        }
    },
    // {
    //     path: '/projects/create',
    //     name: 'Projects_Create',
    //     component: () => import('@/views/processes/create.vue'),
    //     meta: {
    //         authRequired: true,
    //         permission: 'projects.store'
    //     }
    // },
    // {
    //     path: '/projects/:id',
    //     name: 'Projects_Detail',
    //     component: () => import('@/views/projects/show.vue'),
    //     meta: {
    //         authRequired: true,
    //         permission: 'projects.show'
    //     }
    // },
]
